import { getConnectionOrVendorType, isDetectedDataset } from 'js/lib/ResourceUtils';
import has from 'lodash/has';
import { useSelector } from 'react-redux';
import {
  RESOURCE_TYPE_CREDENTIAL_GROUP,
  RESOURCE_TYPE_CREDENTIALS,
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_FLOW,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_SOURCE,
} from 'js/constants/resourceTypes';
import { createSelector } from 'reselect';

export function getResourceEntityKey(resourceType) {
  if (!resourceType) {
    return undefined;
  }
  const keys = {
    [RESOURCE_TYPE_SINK]: 'sink',
    [RESOURCE_TYPE_SOURCE]: 'source',
    [RESOURCE_TYPE_FLOW]: 'source',
    [RESOURCE_TYPE_DATA_SET]: 'dataSet',
    [RESOURCE_TYPE_CREDENTIALS]: 'credential',
    [RESOURCE_TYPE_CREDENTIAL_GROUP]: 'credentialsGroup',
  };
  return keys[resourceType];
}

const resourceMetaSelector = createSelector(
  [(state: any) => state.entities, (state: any) => state.paging.metaInfoById],
  (entities, metaInfoById) => {
    return {
      entities,
      metaInfoById,
    };
  },
);

export function useResourceMeta(resourceType, id, data_credentials = null) {
  const entityKey = getResourceEntityKey(resourceType);
  const { entities, metaInfoById } = useSelector(resourceMetaSelector);
  if (!entityKey) {
    return {};
  }
  if (!resourceType || !id) {
    return {};
  }
  const { vendors, credentials } = entities;

  let isDetected = false;

  const entity = entities[entityKey + 's'][id];
  if (resourceType === RESOURCE_TYPE_DATA_SET) {
    isDetected = isDetectedDataset(entity);
  }

  let source = entity;
  if (isDetected) {
    source = entities.sources[entity.data_source];
  }

  const typeKey =
    entityKey === 'credential' || entityKey === 'credentialsGroup' ? 'credentials' : entityKey;

  let connectionOrVendorType = getConnectionOrVendorType(
    source,
    vendors,
    resourceType === RESOURCE_TYPE_DATA_SET ? 'source_type' : typeKey + '_type',
    'vendor_id',
  );

  let credential = {};
  if (!!data_credentials && has(credentials, data_credentials)) {
    credential = credentials[data_credentials];
  }

  const credentialConnectionType =
    credential && has(credential, 'id')
      ? getConnectionOrVendorType(credential, vendors, 'credentials_type', 'vendor_id')
      : null;

  const meta =
    connectionOrVendorType && has(metaInfoById, connectionOrVendorType)
      ? metaInfoById[connectionOrVendorType]
      : {};

  return {
    ...meta,
    credential,
    credentialConnectionType,
  };
}
